module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-6.b9fe95b0.jpg";